// Store/selectedDataRecordSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { toast } from "react-toastify";

// THUNK
export const getSelectedDataRecord = createAsyncThunk(
  "selectedDataRecord/getSelectedDataRecord",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/dataProcess/getselecteddatarecord",
        payload,
      );
      toast.success(response.data.message);

      return response.data.items;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Failed to fetch selected data records";

      toast.error(message);

      return rejectWithValue(message);
    }
  },
);

const selectedDataRecordSlice = createSlice({
  name: "selectedDataRecord",

  initialState: {
    data: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getSelectedDataRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getSelectedDataRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })

      .addCase(getSelectedDataRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default selectedDataRecordSlice.reducer;
